import { useEffect, useRef, useState } from 'react';

export interface CheckboxDropdownOption {
  value: string;
  label: string;
}

interface CheckboxDropdownProps {
  options: CheckboxDropdownOption[];
  selected: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
}

export function CheckboxDropdown({ options, selected, onChange, placeholder = 'Seleccionar...' }: CheckboxDropdownProps) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  function toggleValue(value: string) {
    onChange(selected.includes(value) ? selected.filter(v => v !== value) : [...selected, value]);
  }

  const selectedOptions = options.filter(o => selected.includes(o.value));

  return (
    <div className="ms-wrap" ref={wrapRef}>
      <div className="ms-display" onClick={() => setOpen(o => !o)}>
        {selectedOptions.length === 0 ? (
          <span className="ms-ph">{placeholder}</span>
        ) : (
          selectedOptions.map(o => (
            <span key={o.value} className="ms-chip">
              {o.label}
            </span>
          ))
        )}
        <span className="ms-arrow">⌄</span>
      </div>
      {open && (
        <div className="ms-dropdown">
          {options.map(o => {
            const on = selected.includes(o.value);
            return (
              <div key={o.value} className="ms-opt" onClick={() => toggleValue(o.value)}>
                <span className={`ms-check${on ? ' on' : ''}`}>{on ? '✓' : ''}</span>
                {o.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
